import { VariableType } from 'json-to-graphql-query';
export const RoleInputVariables = { parentId: 'Int', name: 'String!' };
export const RoleInputArgs = { parentId: new VariableType('parentId'), name: new VariableType('name') };
//# sourceMappingURL=roleInput.js.map